module.exports = __webpack_public_path__ + "img/h_logo02.9263a8a.png";